import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "align-self-center mr-3"
}
const _hoisted_2 = ["innerHTML"]

import { useSlots } from 'vue';

type Props = {
  title?: string;
  text?: string;
  icon?: string;
  inline?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoBox',
  props: {
    title: {},
    text: {},
    icon: { default: '$bellOutline' },
    inline: { type: Boolean }
  },
  setup(__props: any) {



const slots = useSlots();

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _directive_orphans = _resolveDirective("orphans")!

  return (_openBlock(), _createBlock(_component_v_sheet, { class: "pa-3 f-16 d-flex border-md" }, {
    default: _withCtx(() => [
      (_ctx.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, { class: "i sz-red--text" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.icon), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("h4", {
              key: 0,
              class: _normalizeClass(["sz-red--text font-weight-bold", { 'd-inline': _ctx.inline }])
            }, _toDisplayString(_ctx.title), 3))
          : _createCommentVNode("", true),
        (_ctx.text)
          ? _withDirectives((_openBlock(), _createElementBlock("p", {
              key: 1,
              class: _normalizeClass(["sz-primary-grey--text font-weight-regular", { 'd-inline': _ctx.inline }]),
              innerHTML: _ctx.text
            }, null, 10, _hoisted_2)), [
              [_directive_orphans]
            ])
          : _createCommentVNode("", true),
        (_unref(slots).default)
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["sz-primary-grey--text font-weight-regular", { 'd-inline': _ctx.inline }])
            }, [
              _renderSlot(_ctx.$slots, "default")
            ], 2)), [
              [_directive_orphans]
            ])
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})